// extracted by mini-css-extract-plugin
export default {"small_italic_text":"lP","wrapper":"mP","page":"nP","topblock":"oP","nextBtn":"pP","bottomnav":"qP","MyClassEnterDone":"rP","topname":"sP","text":"tP"};
    if(module.hot) {
      // 1738064242589
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  